export default __webpack_public_path__ + "static/mongodb-2febfc171f5d480fe0727c4878140b49.png";